<template>
  <div class="hoist-apply">
    <div class="content">
      <!-- 查询栏 -->
      <div class="option-panel">
        <el-form inline :model="param.params" class="demo-form-inline" label-width="70px">
          <el-form-item label="开始时间">
            <el-date-picker
              style="width: 140px"
              v-model="param.params.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              size="mini"
              @change="getData('search')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              style="width: 140px"
              v-model="param.params.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              size="mini"
              @change="getData('search')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="作业完成状态" label-width="100px">
            <el-select
              style="width: 140px"
              v-model="param.params.zyzt"
              placeholder="请选择"
              size="mini"
              @change="getData('search')"
              clearable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div>
            <el-form-item label="姓名">
              <el-input
                  style="width: 140px"
                  v-model.trim="param.params.xm"
                  size="mini"
                  @change="getData('search')"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="工号">
              <el-input
                  style="width: 140px"
                  v-model.trim="param.params.zyfzr2"
                  size="mini"
                  @change="getData('search')"
              >
              </el-input>
            </el-form-item>
          </div>
          <!-- <el-form-item label="流程状态">
            <el-select
              style="width: 160px"
              v-model="param.params.taskStatus"
              placeholder="请选择"
              size="mini"
              @change="getData('search')"
              clearable
            >
              <el-option
                v-for="item in approvalStatusOpt"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
      <!-- 吊装申请表格 -->
      <el-table
        :data="tableData"
        border
        height="calc(100vh - 360px)"
        style="width: 100%; margin-bottom: 20px;"
        :header-cell-style="{ backgroundColor: '#f6f6f6', color: '#666' }"
        @sort-change="getData"
        v-loading="loading"
      >
        <el-table-column label="序号" type="index" align="center" width="60" fixed>
          <template slot-scope="scope">
            <!-- 有分页时，序号显示 -->
            <span>
              {{ (param.page - 1) * param.size + scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in tableColumn"
          :fixed="item.fiexd"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :sortable="item.sortable"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        size="mini"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 20, 50, 100]"
        :page-size.sync="param.size"
        :total="total"
        :current-page.sync="param.page"
        @current-change="getData"
        @size-change="getData"
        align="center"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as hoistApplyApi from '../../../api/hoistApply'
import * as tmplApi from '@/api/templateApi'
import { formatDate } from '../../../util/formatUtil'
export default {
  data() {
    return {
      tableColumn: [
        { label: '作业负责人', prop: 'xm', width: 100 },
        { label: '工号', prop: 'gh' },
        { label: '名称', prop: 'title', width: 240 },
        { label: '发起时间', prop: 'CreateTime', width: 180, sortable: true },
        { label: '需求时间', prop: 'xqsj', width: 180, sortable: true },
        { label: '吊装区域', prop: 'dzqy', width: 150, sortable: true },
        { label: '当前状态', width: 120, prop: 'zyzt' },
        { label: '项目号', prop: 'xmbh' },
        { label: '吊装类型', prop: 'dclx' },
        { label: '数量', prop: 'sl' }
      ],
      tableData: [],
      timeOptions: [
        { label: '8:15-12:15', value: '8:15-12:15' },
        { label: '13:45-17:45', value: '13:45-17:45' },
        { label: '19:00-21:00', value: '19:00-21:00' }
      ],
      statusOptions: [
        { label: '已完成', value: '已完成' },
        { label: '作业中', value: '作业中' },
        { label: '未开始', value: '未开始' },
        { label: '未完成', value: '未完成' }
      ],
      approvalStatusOpt: [
        { label: '审批中', value: '审批中' },
        { label: '已同意', value: '已同意' },
        { label: '已拒绝', value: '已拒绝' },
        { label: '已撤销', value: '已撤销' }
      ],
      param: {
        page: 1,
        size: 15,
        params: {
          startDate: this.getDate(),
          endDate:this.getEndData()
        }
      },
      total: 0,
      loading: false
    }
  },
  mounted() {
    //标记从哪个页面跳过来的，mb 表示移动端
    if (this.$route.query.number) {
      this.param.params.number = this.$route.query.number
    }
    this.getData()
  },
  methods: {
    getData(column) {
      if (column) {
        if (column === 'search') {
          this.param.page = 1
        } else {
          this.param['desc'] = ''
          this.param['asc'] = ''
          if (column.order === 'descending') {
            this.param['desc'] = column.prop
          } else {
            this.param['asc'] = column.prop
          }
        }
      }
      this.loading = true
      // 获取吊装申请列表
      hoistApplyApi.detailPageData(this.param).then((res) => {
        this.loading = false
        if (res.success) {
          res.data.data.forEach((item) => {
            if (!item.xm) {
              item.xm = '未分配'
            }
          })
          this.tableData = res.data.data
          this.total = res.data.total
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getDate() {
      console.log('时间')
      return formatDate(new Date(), 'yyyy-MM-dd')
    },
    getEndData(){
      return formatDate(new Date(), 'yyyy-MM-dd')
    },
    handleClick(row) {
      // 跳转吊装申请详情页
      let params = {
        funCode: '10001722',
        businessId: row.ID,
        type: 1
      }
      tmplApi.shareInfo(params).then((res) => {
        if (res.success) {
          this.$router.push({
            path: '/ddFlow?funCode=10001722' + '&id=' + row.ID
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hoist-apply {
  /deep/ .el-table .el-table__cell {
    padding: 4px 0;
  }
  .content {
    padding: 14px;
  }
}
</style>
